export const QA_REVIEW_SERVICE_TYPE_ID = 1;
export const MEDICAL_REVIEW_SERVICE_TYPE_ID = 2;
export const MSA_REDUCTION_SERVICE_TYPE_ID = 3;
export const RATE_AGE_SERVICE_TYPE_ID = 4;
export const INVOICE_SERVICE_TYPE_ID = 5;
export const REFUND_SERVICE_TYPE_ID = 6;
